
import React from 'react';
import PropTypes from 'prop-types';

import SearchBarSmall from './SearchBarSmall';
import SearchBarLarge from './SearchBarLarge';

const SearchBar = ({ domain }) => {
    return (
        <div>
            <SearchBarSmall />
            <SearchBarLarge domain={domain} />
        </div>
    );
};

SearchBar.propTypes = {
    domain: PropTypes.string.isRequired
};

export default SearchBar;



// WEBPACK FOOTER //
// ./src/components/Header/MoveableDiv/SearchBar/SearchBar.jsx